export const ROUTE = "secret-wasm";
